import _ from 'lodash';
import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import useFetch from './use-fetch';
import { format } from 'date-fns';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from './use-global-context';
import useHeader from './use-header';

const initialState = {
  loading: false,
  formLoading: false,
  modalLoading: false,
  showEmployeeModal: false,
  showForm: false,
  showModal: false,
  showCredentialModal: false,
  showPressMailModal: false,
  detail: {},
  modalData: {},
  selected: {},
  model: {}
};

function useEventAccreditApproval() {
  const history = useHistory(),
    { id } = useParams(),
    { actions: headerActions } = useHeader(),
    { state: { eventAccreditApproval = initialState }, dispatch } = useGlobalContext();

  const failure = (error) => {
    dispatch({ type: 'eventAccreditApproval', payload: { loading: false, modalLoading: false, formLoading: false }});
    showMessage('error', error);
  };

  useEffect(() => {
    dispatch({ type: 'eventAccreditApproval', payload: initialState });
    // eslint-disable-next-line
  }, []);

  const { data: model, mutate, error } = useFetch({ url: 'events/load-checklist', params: { id } });

  if (error) {
    failure(error);
    history.push('/events');
  }

  useEffect(() => {
    headerActions.configure({
      title: `Evento (#${id}) - Checklist`,
      loading: _.get(eventAccreditApproval, 'loading', false),
    });
    // eslint-disable-next-line
  }, [eventAccreditApproval]);

  const companyId = _.get(eventAccreditApproval, 'selected.companyId');
  const { data: detail, mutate: mutateDetail } = useFetch(!companyId ? null : { url: 'events/load-checklist-detail', params: { id, companyId } });

  const loadDetail = async (selected) => {
    dispatch({ type: 'eventAccreditApproval', payload: { selected, showForm: true } });
  };

  const hideDetail = async () => {
    dispatch({ type: 'eventAccreditApproval', payload: { detail: {}, selected: {}, showForm: false }});
  };

  const openEditModal = (modalData, mode) => {
    dispatch({ type: 'eventAccreditApproval', payload: { modalData: { ...modalData, mode }, showModal: true }});
  };

  const closeEditModal = () => {
    dispatch({ type: 'eventAccreditApproval', payload: { modalData: {}, showModal: false }});
  };

  const saveEditModal = async (params) => {
    let bind = _.find(_.get(eventAccreditApproval, 'detail.employees'), (r) => r.id !== params.id && _.get(r, 'person.id') === _.get(params, 'person.id')),
      companyId = _.get(eventAccreditApproval, 'selected.company.id');

    if (bind) {
      return failure(new Error(`Colaborador "${_.get(params, 'person.name')}" já está associado a uma função nesse evento!`));
    }
    try {
      dispatch({ type: 'eventAccreditApproval', payload: { modalLoading: true } });
      await api.put(`events/save-person`, { ...params, eventId: id, companyId });
      loadDetail(eventAccreditApproval.selected);
      mutateDetail(detail);
      dispatch({ type: 'eventAccreditApproval', payload: { modalLoading: false, modalData: {}, showModal: false } });
      showMessage('success', `Colaborador alterado com sucesso!`);
    } catch (error) {
      failure(error);
    }
  };

  const update = async (supplier, employee, action) => {
    let params = {
        action,
        id,
        blacklist: employee.blacklist,
        status: employee.status,
        employeeId: employee.id,
        companyId: supplier.companyId,
      };

    try {
      dispatch({ type: 'eventAccreditApproval', payload: { formLoading: true } });
      await api.put(`events/save-checklist`, params);
      showMessage('success', `Colaborador alterado com sucesso!`);
      dispatch({ type: 'eventAccreditApproval', payload: { formLoading: false } });
      mutate(model);
      mutateDetail(detail);
    } catch (error) {
      failure(error);
    }
  };

  const openCredentialModal = () => {
    let modalData = { emails: _.get(detail, 'companyEmail') || '' };
    dispatch({ type: 'eventAccreditApproval', payload: { showCredentialModal: true, modalData }});
  };

  const closeCredentialModal = () => {
    dispatch({ type: 'eventAccreditApproval', payload: { showCredentialModal: false, modalData: {} }});
  };

  const createCredentials = async (supplier, mode, emails) => {
    let params = { id: id, companyId: supplier.companyId, mode, emails },
      filename = `credenciais-${_.get(supplier, 'company.identify')}-${format(new Date(), 'yyyy-MM-dd')}.pdf`,
      isDownload = mode === 'download';

    try {
      dispatch({ type: 'eventAccreditApproval', payload: { modalLoading: true } });
      let response = await api.get(`events/create-credentials`, { params, responseType: 'blob' });

      if (isDownload) {
        api.download(response, filename);
      }
      dispatch({ type: 'eventAccreditApproval', payload: { showCredentialModal: false, modalLoading: false, modalData: {} } });

      showMessage('success', `Credenciais geradas com sucesso!`);
    } catch (error) {
      failure(error);
    }
  };

  const openPressMailModal = () => {
    let modalData = { templates: _.get(detail, 'templates') || [] };
    dispatch({ type: 'eventAccreditApproval', payload: { showPressMailModal: true, modalData }});
  };

  const closePressMailModal = () => {
    dispatch({ type: 'eventAccreditApproval', payload: { showPressMailModal: false, modalData: {} }});
  };

  const submitPressMail = async (values) => {
    let params = { eventId: id, companyId: _.get(eventAccreditApproval, 'selected.companyId'), templateId: values.id };
    try {
      dispatch({ type: 'eventAccreditApproval', payload: { modalLoading: true } });
      await api.post(`events/send-press-mail`, params);
      dispatch({ type: 'eventAccreditApproval', payload: { showPressMailModal: false, modalLoading: false, modalData: {} } });
      showMessage('success', `Email enviado com sucesso!`);
    } catch (error) {
      failure(error);
    }
  };

  const openEmployeeModal = (modalData) => {
    dispatch({ type: 'eventAccreditApproval', payload: { modalData, showEmployeeModal: true }});
  };

  const closeEmployeeModal = () => {
    dispatch({ type: 'eventAccreditApproval', payload: { modalData: {}, showEmployeeModal: false }});
  };

  const saveEmployeeModal = async (params) => {
    try {
      dispatch({ type: 'eventAccreditApproval', payload: { modalLoading: true } });
      await api.put(`events/matchday-save-person`, { eventId: id, ...params.employee});
      mutate(model);
      mutateDetail(detail);
      dispatch({ type: 'eventAccreditApproval', payload: { modalLoading: false, modalData: {}, showEmployeeModal: false } });
      showMessage('success', `Colaborador vinculado com sucesso!`);
    } catch (error) {
      failure(error);
    }
  };

  const listPersons = async (term, callback) => {
    try {
      let companyId = _.get(eventAccreditApproval, 'selected.companyId');
      const response = await api.get(`events/list-persons`, { params: { term, companyId } });
      callback(response.data);
    } catch (error) {
      failure(error);
    }
  };

  const listPersonsWithSupplier = async (term, supplier, callback) => {
    try {
      let companyId = _.get(supplier, 'id');
      const response = await api.get(`events/list-persons`, { params: { term, companyId } });
      callback(response.data);
    } catch (error) {
      failure(error);
    }
  };

  const listRoles = async (term, callback) => {
    try {
      const response = await api.get(`events/list-roles`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error);
    }
  };

  const listSuppliers = async (term, callback) => {
    try {
      const response = await api.get(`events/list-suppliers`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error);
    }
  };

  const exportPersonsXlsx = async (companyId) => {
    dispatch({ type: 'eventAccreditApproval', payload: { loading: true } });

    try {
      let response = await api.get(`events/export-persons-xlsx`, { responseType: 'blob', params: { eventId: id, companyId } }),
        filename = `colaboradores-evento-${format(new Date(), 'dd-MM-yyyy')}.xlsx`;
      api.download(response, filename);

      dispatch({ type: 'eventAccreditApproval', payload: { loading: false } });
    } catch (error) {
      failure(error);
    }
  };

  return {
    state: {
      ...eventAccreditApproval,
      model,
      detail,
      loading: !model
    },
    actions: {
      update,
      loadDetail,
      hideDetail,
      listPersons,
      listPersonsWithSupplier,
      listRoles,
      listSuppliers,
      saveEditModal,
      openEditModal,
      closeEditModal,
      createCredentials,
      openCredentialModal,
      closeCredentialModal,
      openPressMailModal,
      closePressMailModal,
      submitPressMail,
      openEmployeeModal,
      saveEmployeeModal,
      closeEmployeeModal,
      exportPersonsXlsx,
    }
  }
}

export default useEventAccreditApproval;